(function () {
  'use strict'

  angular.module('MktzapApp.Controllers')
    .controller('BadwordsConfigController', badwordsconfigsController);

  badwordsconfigsController.$inject = ['$scope', 'BadwordsConfigService', 'NotificationService', '$rootScope', 'FoundationApi', 'Upload', 'LangService','ngTableParams'];

  function badwordsconfigsController ($scope, BadwordsConfigService, NotificationService, $rootScope, FoundationApi, Upload, LangService, ngTableParams) {
    var vm = this
    vm.badWords = []
    vm.newBadWords = ''
    vm.labelsPage = ''
    getBadWords()

    LangService
    .getPageLabels({ 'page': 'menu.config.badwords' })
    .$promise
    .then(function (data) {
      vm.labelsPage = data.lang;
    });


    function getBadWords(){
      vm.filterBadWord = ""
      if ($rootScope.allowedRoles([$rootScope.profiles.ROLE_ADMIN])) {
        BadwordsConfigService
          .getConfigs()
          .$promise
          .then(function (data) {
            if (data.badWords) {
              vm.badWords = angular.copy(data.badWords)
              vm.showFilter = angular.copy(data.badWords)
              vm.getFiltered(angular.copy(data.badWords))
              return
            }
            vm.showFilter = []
            vm.badWords = []
          })
          .catch(function (data) {
            NotificationService.errorHandler(data, vm.labelsPage.error_get)
          });
      }
    }

    vm.getFiltered = () => {
      vm.tableParams = new ngTableParams({
          page: 1,
          count: 30,
      }, {
          total: vm.showFilter.length,
          getData: function($defer, params) {
            $defer.resolve(vm.showFilter.slice((params.page() - 1) * params.count(), params.page() * params.count()))
            params.total(vm.showFilter.length)
          }
      })
    }

    vm.filterItems = () => {
      vm.showFilter = vm.badWords.filter((word) => {
        return word.indexOf(vm.filterBadWord.toLowerCase()) !== -1
      })
      vm.getFiltered()
    }

    $scope.save = function (data) {
      if (!vm.newBadWords) {
        NotificationService.errorHandler(data, vm.labelsPage.word_required)
        return false;
      }
      if (vm.badWords.indexOf(vm.newBadWords.toLowerCase()) !== -1) {
        NotificationService.errorHandler(data, vm.labelsPage.word_exist)
        return false;
      }
      vm.badWords.push(vm.newBadWords.toLowerCase())
      vm.badWords.sort()
      BadwordsConfigService
          .saveConfigs(vm.badWords)
          .$promise
          .then(function (data) {
            vm.newBadWords = '';
            getBadWords()
            NotificationService.successHandler(data, vm.labelsPage.register_success)
          })
          .catch(function (data) {
            NotificationService.errorHandler(data, vm.labelsPage.error)
          })
    }

    vm.deleteBadWordsModal = function (badWord) {
      vm.badWordSelected = badWord
      FoundationApi.publish('deleteBadWordsModal', 'open')
    }

    vm.delete = function () {
      vm.badWords.splice(vm.badWords.indexOf(vm.badWordSelected),1)
      BadwordsConfigService
          .saveConfigs(vm.badWords)
          .$promise
          .then(function (data) {
            getBadWords()
            NotificationService.successHandler(data, vm.labelsPage.register_success)
          })
          .catch(function (data) {
            NotificationService.errorHandler(data, vm.labelsPage.error);
          })
      FoundationApi.publish('deleteBadWordsModal', 'close')
    }

    vm.edit = function (badWord) {
      vm.editBadWord = badWord
      vm.badWordSelected = badWord
      FoundationApi.publish('modal', 'open')
    }

    vm.import = function () {
      FoundationApi.publish('importModal', 'open')
    }

    vm.update = function () {
      vm.badWords.splice(vm.badWords.indexOf(vm.editBadWord),1)
      vm.badWords.push(vm.badWordSelected.toLowerCase())
      vm.badWords.sort()
      vm.badWordSelected=''
      BadwordsConfigService
          .saveConfigs(vm.badWords)
          .$promise
          .then(function (data) {
            getBadWords()
            NotificationService.successHandler(data, vm.labelsPage.edit_success)
          })
          .catch(function (data) {
            NotificationService.errorHandler(data, vm.labelsPage.error)
          })
      FoundationApi.publish('modal', 'close')
    }

    //Upload codes

  window.upload_file = upload_file;
  vm.file_explorer = file_explorer;

  var fileobj;
  function upload_file (e) {
    e.preventDefault();
    fileobj = e.dataTransfer.files[0];
    validateFileUpload(fileobj);
  }

  function file_explorer () {
    document.getElementById('selectfile').click();
    document.getElementById('selectfile').onchange = function () {
      fileobj = document.getElementById('selectfile').files[0];
      validateFileUpload(fileobj);
    };
  }

  function validateFileUpload (file_obj) {
    vm.uploadedFile = null;
    if (file_obj != undefined) {
      if (file_obj.type !== 'text/csv' && file_obj.type !== 'application/vnd.ms-excel') {
        NotificationService.errorHandler(file_obj, vm.labelsPage.csv_error)
      } else {
        vm.uploadedFile = file_obj;
        NotificationService.successHandler(file_obj, vm.labelsPage.upload_success)
      }
    } else {
      NotificationService.errorHandler(file_obj, vm.labelsPage.error)
    }
  }

    vm.saveUploadedFile = () => {
      Upload.upload({
        url: frontUrl + '/upload-badwords-data',
        file: vm.uploadedFile
      })
      .then(function (response) {
        vm.badWords = response.data.updated
        let message = vm.labelsPage.success
          .replace('{1}', response.data.inserts)
          .replace('{2}', response.data.exists)
          getBadWords()
        NotificationService.successHandler(response,  message, 10000)
        vm.uploadedFile = null
        FoundationApi.publish('importModal', 'close')
      })
      .catch(function (response){
        NotificationService.errorHandler(response, vm.labelsPage.error)
      })
    }
  }
})();
